export default __webpack_public_path__ + "favicon-167.png";